import { render, staticRenderFns } from "./IndexScriptModal.vue?vue&type=template&id=3208a80e"
import script from "./IndexScriptModal.vue?vue&type=script&lang=js"
export * from "./IndexScriptModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports